import React from 'react';
import {
  Document,
  PDFViewer,
  Page,
  StyleSheet,
  Text,
  View,
  Image,
  Font
} from '@react-pdf/renderer';

// Register font
Font.register({
  family: 'Roboto',
  fonts: [
    { src: '/Roboto-Regular.ttf' },
    { src: '/Roboto-Bold.ttf', fontWeight: 'bold' }
  ]
});

const styles = StyleSheet.create({
  page: {
    padding: 20,
    fontFamily: 'Roboto'
  },
  heading: {
    fontSize: 18,
    textAlign: 'center',
    marginBottom: 20
  },
  line: {
    height: 0.6,
    backgroundColor: 'black',
    marginVertical: 10,
    marginTop: '40px'
  },
  line2: {
    height: 0.4,
    backgroundColor: 'black',
    marginVertical: 10
  },
  contentContainer: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginTop: 0,
    marginBottom: 0,
    border: '1px Solid black',
    padding: '10px'
  },
  contentContainer2: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginTop: 0,
    marginBottom: 0
  },
  column: {
    flex: 1,
    paddingHorizontal: 10
  },
  row: {
    flexDirection: 'row',
    marginBottom: 0,
    borderBottomWidth: 0.5,
    borderBottomColor: '#ccc',
    borderBottomStyle: 'solid'
  },
  text: {
    fontSize: 7
  },
  textBold: {
    fontSize: 9,
    fontWeight: 'bold'
  },
  textUnderlined: {
    textDecoration: 'underline'
  },
  columnHeader: {
    width: '10%',
    backgroundColor: '#1976D2',
    color: 'white',
    padding: 5,
    textAlign: 'center',
    fontSize: 8,
    fontWeight: 'bold'
  },
  columnContent: {
    width: '10%',
    padding: 6,
    textAlign: 'center',
    alignItems: 'center',
    fontSize: 7
  },
  totalRow: {
    flexDirection: 'row',
    marginTop: 20,
    justifyContent: 'flex-end',
    width: '100%'
  },
  totalLabel: {
    fontSize: 9,
    fontWeight: 'bold',
    padding: 5,
    width: '10%',
    textAlign: 'right',
    color: '#1976D2'
  },
  totalValue: {
    fontSize: 9,
    fontWeight: 'bold',
    padding: 5,
    width: '8%',
    textAlign: 'left',
    color: '#1976D2'
  }
});

const fullScreenStyles = {
  container: {
    position: 'fixed',
    top: 0,
    left: 0,
    width: '100vw',
    height: '100vh',
    zIndex: 1000,
    backgroundColor: 'white'
  }
};

const COLORS = ['#f0f0f0', '#e0e0e0'];

export const DiscountRegisterReportPdf = ({ data }) => {
  console.log('PDF Data:', data);
  let totalDiscount = 0;
  let totalBillAmt = 0;

  function formatDate(dateString) {
    if (!dateString) return "-";
    const date = new Date(dateString);
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    return `${day}/${month}/${year}`;
  }

  function formatCurrency(amount) {
    const num = parseFloat(amount) || 0;
    return num.toFixed(2);
  }

  const indoorData = data?.indoorServiceData?.data || [];
  const stats = data?.indoorServiceData?.stats || { disc_amt: 0, bill_amt: 0 };

  return (
    <div style={fullScreenStyles.container}>
      <PDFViewer width="100%" height="100%" showToolbar>
        <Document title="Discount Register Report">
          <Page size="A4" orientation="landscape" style={styles.page}>
            <Image
              src="/logo_Hospital_m.jpeg"
              style={{ width: '100%', height: '80px', marginBottom: 10 }}
              fixed
            />
            
            {/* Header Row */}
            <View style={styles.row}>
              <Text style={styles.columnHeader}>Sr No.</Text>
              <Text style={{ ...styles.columnHeader, width: '15%' }}>Patient Name</Text>
              <Text style={styles.columnHeader}>UHID No.</Text>
              <Text style={styles.columnHeader}>Adm No.</Text>
              <Text style={{ ...styles.columnHeader, width: '12%' }}>Doctor Name</Text>
              <Text style={styles.columnHeader}>Sponsor</Text>
              <Text style={styles.columnHeader}>Adm Date</Text>
              <Text style={styles.columnHeader}>Bill Amt.</Text>
              <Text style={styles.columnHeader}>Discount</Text>
              <Text style={styles.columnHeader}>Created By</Text>
            </View>

            {/* Data Rows */}
            {indoorData.map((item, index) => {
              const billAmount = (parseFloat(item.total_amt) || 0) + (parseFloat(item.total_room_charge) || 0);
              const discountAmount = parseFloat(item.disc_amt) || 0;
              
              totalBillAmt += billAmount;
              totalDiscount += discountAmount;

              return (
                <View 
                  key={index} 
                  style={{ 
                    ...styles.row, 
                    backgroundColor: COLORS[index % COLORS.length]
                  }}
                >
                  <Text style={styles.columnContent}>{index + 1}</Text>
                  <Text style={{ ...styles.columnContent, width: '15%', textAlign: 'left', paddingLeft: 8 }}>
                    {`${item.patient?.name_suffix || ''} ${item.patient?.first_name || ''} ${item.patient?.last_name || ''}`.trim() || '-'}
                  </Text>
                  <Text style={styles.columnContent}>{item.patient?.uhid || '-'}</Text>
                  <Text style={styles.columnContent}>{item.ipd_no || '-'}</Text>
                  <Text style={{ ...styles.columnContent, width: '12%', textAlign: 'left' }}>
                    {item.consultant?.name || item.patient?.consultant?.name || '-'}
                  </Text>
                  <Text style={styles.columnContent}>{item.patient?.sponsor?.name || '-'}</Text>
                  <Text style={styles.columnContent}>{formatDate(item.date)}</Text>
                  <Text style={{ ...styles.columnContent, textAlign: 'right' }}>{formatCurrency(billAmount)}</Text>
                  <Text style={{ ...styles.columnContent, textAlign: 'right', paddingRight: 8 }}>{formatCurrency(discountAmount)}</Text>
                  <Text style={styles.columnContent}>{item.createdBy || '-'}</Text>
                </View>
              );
            })}

            {/* Total Row */}
            <View style={styles.totalRow}>
              <Text style={styles.totalLabel}>Total Bill:</Text>
              <Text style={styles.totalValue}>{formatCurrency(totalBillAmt)}</Text>
              <Text style={styles.totalLabel}>Total Discount:</Text>
              <Text style={styles.totalValue}>{formatCurrency(totalDiscount)}</Text>
            </View>
          </Page>
        </Document>
      </PDFViewer>
    </div>
  );
};

export default DiscountRegisterReportPdf;